import { deviceTypes } from 'z-js-commons';

export default {
    info: {
        title: 'I RISULTATI DELLA TUA RICERCA',
        description: "Le verifiche vengono presentate dalla più recente. Per ognuna vedi l'anno, gli argomenti e il numero di esercizi presenti.",
        name: 'InvalsiHomeworkCardContainerWithTutorial',
        tutorialName: 'verifica_risultati-INVALSI'
    },
    [deviceTypes.DESKTOP]: {
        popoverPlacement: 'right',
        xPlacement: 'LEFT',
        yPlacement: 'TOP',
        xOffset: 35,
        yOffset: -35
    },
    [deviceTypes.PHONE]: {
        popoverPlacement: 'bottom',
        xPlacement: 'LEFT',
        yPlacement: 'TOP',
        xOffset: 10,
        yOffset: -30
    }
};
